/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadResource {
    getFixupPrototypeFunction() { return WorkloadResource.fixupPrototype; }

    static newInstance(model: Partial<WorkloadResource>): WorkloadResource {
        let obj = Object.assign(new WorkloadResource(), model);
        WorkloadResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadResource>): WorkloadResource {
        if (!model) return null;
        return WorkloadResource.newInstance(<WorkloadResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadResource) {
        if (!obj) return;

        models.WorkloadResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadResource): boolean {
        Object.setPrototypeOf(obj, WorkloadResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Unique identifier of the resource
     */
    service_resource_id: string;

    /**
     * ID of account that resource belongs to
     */
    service_account_id: string;

    /**
     * Resource Filter
     */
    resource_filter: string;

    /**
     * Category of resource
     */
    category: string;

    /**
     * Resource Type of resource
     */
    resource_type: string;

    /**
     * Resource (service_resource)
     */
    resource: string;

    /**
     * OperationId associated with resource
     */
    operation_id: string;

    /**
     * Location of resource
     */
    location: string;

    /**
     * Resource identifier
     */
    check_resource_element: string;

    /**
     * Resource name. For any resource type that does not support a name field, resource_name will be null.
     */
    resource_name: string;

    /**
     * Tags associated with resource
     */
    tags: { [key: string]: string; };

    /**
     * Status of the resource
     */
    status: string;

    /**
     * When resource was created
     */
    created_at: Date;

    /**
     * When resource was last updated
     */
    updated_at: Date;

}
